import React from "react";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";
import { AdminOrganizationPage, OrganizationPage } from "./pages";

const OrganizationEntry = () => {
  const { user } = useAuthStore();

  const isAdmin =
    user?.role === "business_unit" || user?.role === "system_admin";

  return isAdmin ? <AdminOrganizationPage /> : <OrganizationPage />;
};

export const organizationRoutes = [
  {
    path: PATHS.ORGANIZATION,
    element: <OrganizationEntry />,
    handle: { permission: { resource: "organization", action: "view" } },
  },
];
